var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50033 11.25V10.0833L3.08366 9.5H1.33366C1.01283 9.5 0.738173 9.38576 0.509701 9.15729C0.281228 8.92882 0.166992 8.65417 0.166992 8.33333V1.91667C0.166992 1.59583 0.281228 1.32118 0.509701 1.09271C0.738173 0.864236 1.01283 0.75 1.33366 0.75H6.00033V1.91667H1.33366V8.33333H10.667V6.58333H11.8337V8.33333C11.8337 8.65417 11.7194 8.92882 11.491 9.15729C11.2625 9.38576 10.9878 9.5 10.667 9.5H8.91699L9.50033 10.0833V11.25H2.50033ZM7.75033 7.75L4.83366 4.83333L5.65033 4.01667L7.16699 5.51875V0.75H8.33366V5.51875L9.85033 4.01667L10.667 4.83333L7.75033 7.75Z",
    fill: "#000A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowser);
export default __webpack_public_path__ + "static/media/browser.460cc207.svg";
export { ForwardRef as ReactComponent };